const iconStyles = {
  lineHeight: 0,
  marginTop: {
    xs: '6px',
    xl: '6px',
  },
  flexShrink: 0,
  width: {
    xs: '9px',
    xl: '12px',
  },
  height: {
    xs: '11px',
    xl: '14px',
  },
  marginRight: {
    xs: '8px',
    xl: '10px',
  },
};

const commonIconStyles = (theme) => ({
  lineHeight: 0,
  flexShrink: 0,
  width: '48px',
  height: '48px',
  marginRight: '0.4em',
  [theme.breakpoints.down('sm')]: {
    width: '32px',
    height: '32px',
    margin: 'auto 0.2em auto 0',
    verticalAlign: 'middle',
  },
});

const emojiStyles = {
  marginTop: {
    xs: '-1px',
    xl: 0,
  },
  width: '24px',
  height: '24px',
};

const styles = {
  item: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  icon_wrapper: {
    margin: 'auto 0',
    display: 'flex',
  },
  icon_fire: {
    ...iconStyles,
    ...emojiStyles,
  },
  icon_voltage: {
    ...iconStyles,
    ...emojiStyles,
  },
  icon_gift: {
    ...iconStyles,
    ...emojiStyles,
  },
  icon_present: (theme) => ({
    ...commonIconStyles(theme),
  }),
  icon_wallet: (theme) => ({
    ...commonIconStyles(theme),
  }),
  icon_calendar: (theme) => ({
    ...commonIconStyles(theme),
  }),
  icon_computer: (theme) => ({
    ...commonIconStyles(theme),
  }),
  icon_discount: (theme) => ({
    ...commonIconStyles(theme),
  }),
  icon_star: (theme) => ({
    ...commonIconStyles(theme),
  }),
  icon_payment: (theme) => ({
    ...commonIconStyles(theme),
  }),
  icon_default: {
    ...iconStyles,
  },
  icon_list_size_xsmall: {
    width: '8.5px',
    marginTop: {
      xs: '4px',
      xl: '4px',
    },
  },
};

export default styles;
